// src/utils/rankStudents.js
import studentId from "../config";

// ===============================
// Rank student by SECTION
// ===============================
export async function fetchAndRankStudentBySection(className, sectionName) {
  try {
    const sessionId = localStorage.getItem("currentSessionId");

    if (!sessionId || !className || !sectionName) {
      throw new Error("Missing required parameters");
    }

    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/examresults/getExamResultByClassAndSection/class/${className}/section/${sectionName}?sessionId=${sessionId}`
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (!data.length) return null;

    const exam = data[0];

    // Calculate total score for each student
    exam.students.forEach(student => {
      student.totalScore = student.scores.reduce(
        (sum, score) => sum + score.score,
        0
      );
    });

    // Sort students by total score
    exam.students.sort((a, b) => b.totalScore - a.totalScore);

    // Assign rank
    exam.students.forEach((student, index) => {
      student.rank = index + 1;
    });

    // Find logged-in student
    const student = exam.students.find(
      s => s.studentId === studentId
    );

    return student
      ? { studentName: student.studentName, rank: student.rank }
      : null;

  } catch (error) {
    console.error("Section Rank Error:", error.message);
    return null;
  }
}

// ===============================
// Rank student by CLASS
// ===============================
export async function fetchAndRankStudentByClass(className) {
  try {
    const sessionId = localStorage.getItem("currentSessionId");

    if (!sessionId || !className) {
      throw new Error("Missing required parameters");
    }

    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/examresults/getExamResultByClass/class/${className}?sessionId=${sessionId}`
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    const students = [];

    // Collect students from all exams
    data.forEach(exam => {
      exam.students.forEach(student => {
        student.totalScore = student.scores.reduce(
          (sum, score) => sum + score.score,
          0
        );
        students.push(student);
      });
    });

    if (!students.length) return null;

    // Sort & rank
    students.sort((a, b) => b.totalScore - a.totalScore);
    students.forEach((student, index) => {
      student.rank = index + 1;
    });

    const student = students.find(
      s => s.studentId === studentId
    );

    return student
      ? { studentName: student.studentName, rank: student.rank }
      : null;

  } catch (error) {
    console.error("Class Rank Error:", error.message);
    return null;
  }
}
